(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tpsliderr"] && !Shopify.designMode) return;
  try {
    
class FinalSlider {
  constructor(el) {
    this.container = el;
    this.sectionId = this.container.dataset.sectionId;
    this.track = this.container.querySelector('.final-slider-track');
    this.prevButton = this.container.querySelector('.final-slider-button.prev');
    this.nextButton = this.container.querySelector('.final-slider-button.next');
    this.slides = Array.from(this.track?.children || []);
    
    const settingsEl = document.getElementById(`slider-settings-${this.sectionId}`);
    const settings = JSON.parse(settingsEl?.textContent || '{}');
    this.reviewsPerView = settings.reviewsPerView;
    this.autoplay = settings.autoplay;
    this.autoplayDelay = settings.autoplayDelay * 1000;
    
    this.currentIndex = 0;
    this.autoplayInterval = null;

    if (this.slides.length > 0) this.init();
  }
  getSlidesPerPage() { return window.innerWidth < 768 ? 1 : this.reviewsPerView; }
  updateSlider() { const slidesPerPage = this.getSlidesPerPage(); if(!this.track || this.track.clientWidth === 0) return; const slideWidth = this.track.clientWidth / slidesPerPage; this.track.style.transform = `translateX(-${this.currentIndex * slideWidth}px)`; this.updateNavButtons(); }
  updateNavButtons() { if (!this.prevButton || !this.nextButton) return; const slidesPerPage = this.getSlidesPerPage(); this.prevButton.disabled = this.currentIndex === 0; this.nextButton.disabled = this.currentIndex >= this.slides.length - slidesPerPage; }
  goToNext() { const slidesPerPage = this.getSlidesPerPage(); if (this.currentIndex >= this.slides.length - slidesPerPage) { this.currentIndex = 0; } else { this.currentIndex++; } this.updateSlider(); }
  goToPrev() { if (this.currentIndex > 0) { this.currentIndex--; } else { this.currentIndex = this.slides.length - this.getSlidesPerPage(); } this.updateSlider(); }
  startAutoplay() { if (!this.autoplay || this.slides.length <= this.getSlidesPerPage()) return; this.stopAutoplay(); this.autoplayInterval = setInterval(() => this.goToNext(), this.autoplayDelay); }
  stopAutoplay() { clearInterval(this.autoplayInterval); this.autoplayInterval = null; }
  handleResize() { const slidesPerPage = this.getSlidesPerPage(); if (this.currentIndex >= this.slides.length - slidesPerPage) { this.currentIndex = Math.max(0, this.slides.length - slidesPerPage); } this.updateSlider(); }
  
  init() {
    this.nextButton?.addEventListener('click', () => { this.stopAutoplay(); this.goToNext(); this.startAutoplay(); });
    this.prevButton?.addEventListener('click', () => { this.stopAutoplay(); this.goToPrev(); this.startAutoplay(); });
    this.container.addEventListener('mouseenter', () => this.stopAutoplay());
    this.container.addEventListener('mouseleave', () => this.startAutoplay());
    window.addEventListener('resize', () => this.handleResize());
    this.updateSlider();
    this.startAutoplay();
  }
}

function initializeFinalSliders(container = document) { container.querySelectorAll('.final-slider-section-{{ section.id }}').forEach(el => new FinalSlider(el)); }
document.addEventListener('DOMContentLoaded', () => initializeFinalSliders());
if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.classList.contains('final-slider-section-{{ section.id }}')) {
      initializeFinalSliders(e.target);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
